module.exports = {
    RECEIVE_ALL_FIELD_MODE: 'RECEIVE_ALL_FIELD_MODE',
}
